import { useState } from 'react';

const SUBMIT_URL = 'https://ordem-de-servico.stibpalestrasilenciosasp.com.br/pedido.php';

type Props = { servico: string; pagina: string };

const PRAZOS = ['3 meses', '6 meses', '12 meses', '24 meses'];

export default function PacoteAcademiaForm({ servico, pagina }: Props) {
  const [f, setF] = useState({ name: '', company: '', email: '', phone: '', city: 'São Paulo - SP (capital)', unidades: '1', alunos: '', prazo: '12 meses', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'ok' | 'error'>('idle');
  const set = (k: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setF({ ...f, [k]: e.target.value });

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!f.name || !f.phone || !f.email) { setStatus('error'); return; }
    setStatus('sending');
    const summary = [
      `Serviço: ${servico}`,
      `Prazo do contrato: ${f.prazo}`,
      `Academia/empresa: ${f.company}`,
      `Número de unidades: ${f.unidades}`,
      `Alunos por aula: ${f.alunos || 'não informado'}`,
      `Cidade: ${f.city}`,
      `Página de origem: ${pagina}`,
      `Valor base informado na página: R$ 4.900/mês + tarifas (São Paulo capital)`,
      f.message ? `Mensagem: ${f.message}` : '',
    ].filter(Boolean).join('\n');
    try {
      const body = new URLSearchParams();
      body.append('name', f.name);
      body.append('email', f.email);
      body.append('phone', f.phone);
      body.append('company', f.company);
      body.append('eventType', servico);
      body.append('participants', f.alunos);
      body.append('channels', '');
      body.append('city', f.city);
      body.append('dates', `Contrato de ${f.prazo}`);
      body.append('flexibility', 'contrato');
      body.append('duration', f.prazo);
      body.append('message', `Unidades: ${f.unidades}. ${f.message}`);
      body.append('summary', summary);
      const res = await fetch(SUBMIT_URL, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
      setStatus(res.ok ? 'ok' : 'error');
    } catch {
      setStatus('error');
    }
  };

  const input = 'w-full rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white px-4 py-3 font-body text-sm focus:outline-none focus:ring-2 focus:ring-primary';
  const label = 'block font-body text-sm font-semibold text-secondary dark:text-white mb-2';

  return (
    <section id="pacote" className="py-16 bg-gray-50 dark:bg-gray-800/50 scroll-mt-28">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <p className="font-body text-primary font-semibold text-sm uppercase tracking-widest mb-3 text-center">Contrato com academias</p>
        <h2 className="font-heading font-bold text-3xl text-secondary dark:text-white mb-4 text-center">Solicite seu pacote mensal</h2>
        <p className="font-body text-gray-700 dark:text-gray-300 text-center mb-2">
          São Paulo capital: <strong>a partir de R$ 4.900/mês + tarifas</strong> — cerca de <strong>R$ 163 por dia</strong>.
        </p>
        <p className="font-body text-gray-600 dark:text-gray-400 text-sm text-center mb-8">
          Consulte as condições. Mais de uma academia ou unidade: pacote com condições especiais.
        </p>

        {status === 'ok' ? (
          <div className="rounded-2xl bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-700 p-6 text-center font-body text-green-800 dark:text-green-200">
            Recebemos sua solicitação! Nossa equipe vai enviar a proposta do contrato de {f.prazo} em breve. Se preferir, fale agora pelo WhatsApp{' '}
            <a href="https://wa.me/5511917776227" target="_blank" rel="noopener noreferrer" className="underline font-semibold">(11) 91777-6227</a>.
          </div>
        ) : (
          <form onSubmit={submit} className="rounded-3xl bg-white dark:bg-gray-900 shadow-sm p-6 md:p-8 space-y-5">
            <div>
              <label className={label}>Tipo de serviço</label>
              <input className={`${input} bg-gray-100 dark:bg-gray-700`} value={servico} readOnly />
            </div>
            <div>
              <label className={label}>Prazo do contrato <span className="text-primary">*</span></label>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                {PRAZOS.map((p) => (
                  <button type="button" key={p} onClick={() => setF({ ...f, prazo: p })}
                    className={`rounded-xl border px-3 py-3 font-body text-sm font-semibold transition-colors ${f.prazo === p ? 'bg-primary text-secondary border-primary' : 'border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:border-primary'}`}>
                    {p}
                  </button>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div><label className={label}>Nome completo <span className="text-primary">*</span></label><input className={input} value={f.name} onChange={set('name')} required /></div>
              <div><label className={label}>Academia / empresa</label><input className={input} value={f.company} onChange={set('company')} /></div>
              <div><label className={label}>E-mail <span className="text-primary">*</span></label><input type="email" className={input} value={f.email} onChange={set('email')} required /></div>
              <div><label className={label}>WhatsApp <span className="text-primary">*</span></label><input type="tel" className={input} value={f.phone} onChange={set('phone')} required /></div>
              <div><label className={label}>Número de academias/unidades</label>
                <select className={input} value={f.unidades} onChange={set('unidades')}>
                  <option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4 ou mais">4 ou mais</option>
                </select>
              </div>
              <div><label className={label}>Alunos por aula (aprox.)</label><input className={input} value={f.alunos} onChange={set('alunos')} placeholder="Ex.: 25" /></div>
            </div>
            <div><label className={label}>Cidade</label><input className={input} value={f.city} onChange={set('city')} /></div>
            <div><label className={label}>Mensagem</label><textarea className={input} rows={3} value={f.message} onChange={set('message')} placeholder="Dias e horários das aulas, quantidade de salas etc." /></div>
            {status === 'error' && <p className="font-body text-sm text-red-600">Preencha nome, e-mail e WhatsApp, ou tente novamente.</p>}
            <button type="submit" disabled={status === 'sending'} className="w-full font-body font-semibold bg-primary text-secondary px-6 py-4 rounded-full hover:opacity-90 transition-opacity disabled:opacity-60">
              {status === 'sending' ? 'Enviando…' : 'Solicitar proposta do pacote'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
